var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Pipe } from '@angular/core';
import { TimeUnit } from './../util/index';
/**
 * usage:
 *  {{TimeUnit.SECONDS | timeunit : "shortname"}}
 */
export let TimeUnitPipe = class TimeUnitPipe {
    transform(timeUnit, arg1) {
        if (arg1 == "shortname") {
            switch (timeUnit) {
                case TimeUnit.NANOSECONDS: return "ns";
                case TimeUnit.MICROSECONDS: return "μs";
                case TimeUnit.MILLISECONDS: return "ms";
                case TimeUnit.SECONDS: return "sec";
                case TimeUnit.MINUTES: return "min";
                case TimeUnit.HOURS: return "hour";
                case TimeUnit.DAYS: return "day";
                default:
                    throw new Error("Invalid TimeUnit");
            }
        }
        throw new Error(this.constructor.name + " arguments: \"shortname\"");
    }
};
TimeUnitPipe = __decorate([
    Pipe({
        name: 'timeunit'
    }), 
    __metadata('design:paramtypes', [])
], TimeUnitPipe);
//# sourceMappingURL=time-unit.pipe.js.map